import { SleddingIcon } from './SleddingIcon';

/**
 * author: Google
 * id E67044BA-8025-4D61-916C-56DF4D6FFE6D
 * name sledding
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sledding.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanSleddingIcon = SleddingIcon;
export default HumanSleddingIcon